import React from 'react';
import { GroupedAnomalyMarker } from '../../groupedAnomalyMarkers';
import { collectMarkerMetricIncidents } from './anomalyMetricConfig';
import { AnomalyMetricKey, AnomalyMetricSemantics } from '../../../../../../../shared/models/anomaly-detection/models/AnomalyIncidentsResponse';
import AnomalyMultipleMetricsTooltip from './AnomalyMultipleMetricsTooltip';
import AnomalyMarkerSingleMetricTooltip from './AnomalyMarkerSingleMetricTooltip';

interface AnomalyMarkerTooltipProps {
  marker: GroupedAnomalyMarker;
  metricSemantics: Record<AnomalyMetricKey, AnomalyMetricSemantics>;
  dateFormatter?: (raw: string) => string;
}

export const AnomalyMarkerTooltip: React.FC<AnomalyMarkerTooltipProps> = ({
  marker,
  metricSemantics,
  dateFormatter,
}) => {
  const metricIncidents = collectMarkerMetricIncidents(marker);

  if (metricIncidents.length === 0) {
    return null;
  }

  if (metricIncidents.length >= 2) {
    return (
      <AnomalyMultipleMetricsTooltip
        marker={marker}
        metricSemantics={metricSemantics}
        dateFormatter={dateFormatter}
      />
    );
  }

  const { incident, metric, unit } = metricIncidents[0];

  return (
    <AnomalyMarkerSingleMetricTooltip
      dateKey={marker.dateKey}
      incident={incident}
      metric={metric}
      metricSemantics={metricSemantics[metric]}
      valueUnit={unit || undefined}
      dateFormatter={dateFormatter}
    />
  );
};

export default AnomalyMarkerTooltip;
